/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitAutomationForFlow} from '../api'

export const useMutationSubmitAutomationForFlow = createReactQueryMutationHook('submitAutomationForFlow', submitAutomationForFlow)
